/* eslint-disable max-classes-per-file */
import { Action } from '@ngrx/store';
import { OrderDetailsActionTypes } from './order-details.action';
import { CONSULTATION_METHODS } from '../../models/consultation-methods.model';
import { TRANSACTION_NAMES } from '../../models/transaction-names.model';
import { Reason_Code } from '../../common/constants/defines';
import { UserCredentials } from 'src/app/models/userCredential.model';
import { Position } from 'src/app/models/position.model';
import { SenderParty } from '../../models/sender-party.model';
import { SenderContactPoint } from '../../models/sender-contact-point';
import { PostalShoppingScenarios } from 'src/app/models/postal-shopping.model';
/** SetTransactionName */
export class SetTransactionName implements Action {
    /** type */
    public readonly type = OrderDetailsActionTypes.SET_TRANSACTION_NAME;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** transactionName */
        transactionName: TRANSACTION_NAMES,
        /** articleNumber */
        articleNumber?: string,
    }) { }

}
/** SetForwardToChange */
export class SetForwardToChange implements Action {
    /** type */
    public readonly type = OrderDetailsActionTypes.SET_FORWARD_TO_AGENT;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** forwardToAgent */
        forwardToAgent: CONSULTATION_METHODS,
        /** articleNumber */
        articleNumber?: string,
    }) { }

}
/** ChangeOrder */
export class ChangeOrder implements Action {

    /** type */
    public readonly type = OrderDetailsActionTypes.CHANGE_ORDER;
    /**
     *
     * @param payload
     */
    public constructor (public payload?: {
        /** urlForSuccess */
        urlForSuccess: string,
        /** targetUrl */
        targetUrl?: string,
    }) { }
}
/** ResetPositionToOriginal */
export class ResetPositionToOriginal implements Action {

    /** type */
    public readonly type = OrderDetailsActionTypes.RESET_POSITION;
    /** constructor */
    public constructor () { }
}
/** RemoveBeforeUnloadListener */
export class RemoveBeforeUnloadListener implements Action {

    /** type */
    public readonly type = OrderDetailsActionTypes.REMOVE_BEFORE_UNLOAD_LISTENER;
    /**
     * constructor
     */
    public constructor () { }
}

/** SetReturnReasonCode */
export class SetReturnReasonCode implements Action {
    /** type */
    public readonly type = OrderDetailsActionTypes.SET_RETURN_REASON_CODE;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** returnedReasonCode */
        returnedReasonCode: Reason_Code,
        /** articleNumber */
        articleNumber: string,

    }) { }

}
/**  SetUserCredentials */
export class SetUserCredentials implements Action {
    /** type */
    public readonly type = OrderDetailsActionTypes.SET_USER_CREDENTIALS;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** userCredentials */
        userCredentials: UserCredentials,

    }) { }

}
/** UpdateSelectedPosition */
export class UpdateSelectedPosition implements Action {
    /** type */
    public readonly type = OrderDetailsActionTypes.UPDATE_SELECTED_POSITION;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** articleNumber */
        articleNumber: string,
        /** position */
        position: Position[],

    }) { }
}
/** SetRefreshUserData */
export class SetRefreshUserData implements Action {
    /** type */
    public readonly type = OrderDetailsActionTypes.SET_REFRESH_USER_DATA;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** refreshUserData */
        refreshUserData: boolean,
    }) { }
}
/** SetUserAddress */
export class SetUserAddress implements Action {
    /** type */
    public readonly type = OrderDetailsActionTypes.SET_USER_ADDRESS;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** userAddressData */
        userAddressData: {
            /** senderParty */
            senderParty: SenderParty,
            /** senderContactPoints */
            senderContactPoints: SenderContactPoint },
    }) { }
}
/** RemoveForwardToAgent */
export class RemoveForwardToAgent implements Action {

    /** type */
    public readonly type = OrderDetailsActionTypes.REMOVE_FORWARD_TO_AGENT;
    /**
     *
     * @param payload
     */
    public constructor (public payload?: {
        /** articleNumber */
        articleNumber?: string,
    }) { }
}
/** SetCID */
export class SetCID implements Action {
    /** type */
    public readonly type = OrderDetailsActionTypes.SET_C_ID;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** c_id */
        c_id: string,
    }) { }
}
/** SetCameFromOverview */
export class SetCameFromOverview implements Action {
    /** type */
    public readonly type = OrderDetailsActionTypes.SET_CAME_FROM_OVERVIEW;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** cameFromOverview */
        cameFromOverview: boolean,
    }) { }
}
/** SetPostalShoppingScenario */
export class SetPostalShoppingScenario implements Action {
    /** type */
    public readonly type = OrderDetailsActionTypes.SET_POSTAL_SHOPPING_SCENARIO;
    /** constructor */
    public constructor (public payload: {
        /** postalShoppingScenario */
        postalShoppingScenario: PostalShoppingScenarios,
   }) { }
}
/** SetPostalShoppingCustomPositions */
export class SetPostalShoppingCustomPositions implements Action {
    /** type */
    public readonly type = OrderDetailsActionTypes.SET_POSTAL_SHOPPING_CUSTOM_POSITIONS;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** positions */
        positions: { [key: string]: Position[]; },
    }) {

    }
}
